var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @file Divider 分割线
 */
import DividerAntd from 'antd/es/divider';
import styled, { css } from 'styled-components';
export const Divider = (_a) => {
    var { vertical = false, plain } = _a, props = __rest(_a, ["vertical", "plain"]);
    return (_jsx(StyledDivider, Object.assign({}, props, { plain: plain, vertical: vertical ? 1 : 0, type: vertical ? 'vertical' : 'horizontal' }), void 0));
};
const StyledDivider = styled(DividerAntd) `
  &&& {
    margin: 0;
    border-color: rgba(50, 56, 66, 0.1);

    ${props => props.vertical &&
    css `
        top: 0;
        height: 20px;
      `};

    ${props => props.plain &&
    css `
        .ant-divider-inner-text {
          color: ${p => p.theme.text._3};
          font-size: 12px;
        }
      `}
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvRGl2aWRlci9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUE7O0dBRUc7QUFFSCxPQUFPLFdBQWlELE1BQU0saUJBQWlCLENBQUE7QUFFL0UsT0FBTyxNQUFNLEVBQUUsRUFBRSxHQUFHLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQTtBQVcvQyxNQUFNLENBQUMsTUFBTSxPQUFPLEdBQXFCLENBQUMsRUFJekMsRUFBRSxFQUFFO1FBSnFDLEVBQ3hDLFFBQVEsR0FBRyxLQUFLLEVBQ2hCLEtBQUssT0FFTixFQURJLEtBQUssY0FIZ0MscUJBSXpDLENBRFM7SUFDSixPQUFBLENBQ0osS0FBQyxhQUFhLG9CQUNSLEtBQUssSUFDVCxLQUFLLEVBQUUsS0FBSyxFQUNaLFFBQVEsRUFBRSxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxFQUMxQixJQUFJLEVBQUUsUUFBUSxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDLFlBQVksWUFDMUMsQ0FDSCxDQUFBO0NBQUEsQ0FBQTtBQUVELE1BQU0sYUFBYSxHQUFHLE1BQU0sQ0FBQyxXQUFXLENBQUMsQ0FHdkM7Ozs7O01BS0ksS0FBSyxDQUFDLEVBQUUsQ0FDUixLQUFLLENBQUMsUUFBUTtJQUNkLEdBQUcsQ0FBQTs7O09BR0Y7O01BRUQsS0FBSyxDQUFDLEVBQUUsQ0FDUixLQUFLLENBQUMsS0FBSztJQUNYLEdBQUcsQ0FBQTs7bUJBRVUsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxFQUFFOzs7T0FHaEM7O0NBRU4sQ0FBQSJ9